// client/src/utils/vendorInvoiceDestination.ts
//
// MIRRORED FILE - twin of src/utils/vendorInvoiceDestination.js (D95). The server file
// is THE OWNER of "where does this vendor invoice's cost land?"; this is the part the
// screens need (parseDestination, the list filter and the receipt reader stay
// server-side). Change one, change both: mirroredUtilParity.test.js runs them on the
// same inputs.
//
//   united  - Ship Chandlery, the default (a row stored before the field = united)
//   pantry  - the same flow into pantry stock; ON HOLD while PANTRY_DESTINATION_OPEN is false
//   expense - a company bill: billed and paid, but no stock, catalogue price or PO match

export const PANTRY_DESTINATION_OPEN = false;

export const DESTINATIONS = Object.freeze(['united', 'pantry', 'expense'] as const);
export type VendorInvoiceDestination = (typeof DESTINATIONS)[number];
export const DEFAULT_DESTINATION: VendorInvoiceDestination = 'united';

/** An invoice's destination; a row stored before the field existed is `united`. */
export function destinationOf(invoice: { destination?: string | null } | null | undefined): VendorInvoiceDestination {
  const d = invoice && invoice.destination;
  return (DESTINATIONS as readonly string[]).includes(d as string) ? (d as VendorInvoiceDestination) : DEFAULT_DESTINATION;
}

/** The stock location this destination stocks into, or null when it stocks nothing. */
export function stockLocationForDestination(destination: string | null | undefined): 'united' | 'pantry' | null {
  if (destination === 'pantry') return 'pantry';
  if (destination === 'expense') return null;
  return 'united';
}

/** False only for a company expense: no stock-in, no catalogue effects, no PO matching. */
export function isStockDestination(destination: string | null | undefined): boolean {
  return stockLocationForDestination(destination) !== null;
}
